/** Clase para las coberturas opcionales */

import { CoverageInfoCapital } from './CoverageInfoCapital'

export default class CoverageComplete {
  coverageCode: string
  coverageNumber: string
  description: string
  mandatory: boolean
  maxAge: number
  minAge: number
  coverageInfoCapitals: CoverageInfoCapital[]

  constructor(data: any = {}) {
    this.coverageCode = data.coverageCode
    this.coverageNumber = data.coverageNumber
    this.description = data.description
    this.mandatory = data.mandatory
    this.maxAge = data.maxAge
    this.minAge = data.minAge
    this.coverageInfoCapitals = data.coverageInfoCapitals
      ?.map((cic: any) => new CoverageInfoCapital(cic))
      ?.sort(
        (a: CoverageInfoCapital, b: CoverageInfoCapital) =>
          Number(a.sumInsured) - Number(b.sumInsured)
      )
  }
}
